import { ParsedUrlQuery } from 'querystring'

import { currency } from './FormatMoney'

const browserQueryToQueryString = (query: { [key in string]: string }) => {
  // eslint-disable-next-line
  const { tab, page, per, sort, id, amount_billed, amount_paid, ...filters } =
    query

  const pageNumber = Number(page) + 1

  const params = {
    ...(!!page && { page: pageNumber.toString() }),
    ...(!!per && { per }),
    ...(!!sort && { sort })
  }

  const paramsQueryString = new URLSearchParams(params).toString() ?? ''

  const amount =
    !!amount_billed &&
    currency(amount_billed).replaceAll('.', '').replaceAll(',', '.')
  const paid = currency(amount_paid ?? '')
    .replaceAll('.', '')
    .replaceAll(',', '.')
  // Converte received=true para status=paid na API
  const { received, ...restFilters } = filters as { [key: string]: string }
  const filterEntries = {
    ...restFilters,
    ...(!!received && { status: 'paid' }),
    ...(!!amount_billed && { amount_billed: amount || '0' }),
    ...(!!amount_paid && { amount_paid: paid || '0' }),
    ...(id && { customer_uuid: id })
  }

  const filterBy = Object.entries(filterEntries)
    .filter(([, val]) => val)
    .map(([key, val]) => {
      const encodedVal = String(val)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '+')
      return `${key} ${encodedVal}`
    })
    .join(',')

  return `?${paramsQueryString}${
    filterBy ? `&filter_by=${encodeURIComponent(filterBy)}` : ''
  }`
}

export const exportReportData = (query: { [key in string]: string }) => {
  // eslint-disable-next-line
  const { tab, page, per, sort, id, amount_billed, amount_paid, ...filters } =
    query

  const amount = currency(amount_billed ?? '')
    .replaceAll('.', '')
    .replaceAll(',', '.')
  const paid = currency(amount_paid ?? '')
    .replaceAll('.', '')
    .replaceAll(',', '.')
  // Converte received=true para status=paid na API
  const { received: receivedFilter, ...restReportFilters } = filters as {
    [key: string]: string
  }
  const filterReportEntries = {
    ...restReportFilters,
    ...(!!receivedFilter && { status: 'paid' }),
    ...(!!amount_billed && { amount_billed: amount }),
    ...(!!amount_paid && { amount_paid: paid }),
    ...(id && { customer_uuid: id })
  }

  const filter_by = Object.entries(filterReportEntries)
    .filter(([, val]) => val)
    .map(([key, val]) => {
      const encodedVal = String(val)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '+')
      return `${key} ${encodedVal}`
    })
    .join(',')

  return {
    filter_by,
    sort
  }
}

type HandleDeleteFilters = {
  filters: { [key in string]: string } | ParsedUrlQuery
  options: string[]
}

export const handleDeleteQueryFilters = ({
  filters,
  options
}: HandleDeleteFilters) => {
  // Create a shallow copy to avoid mutating the original object
  const currencyFilters = { ...filters }
  options.forEach((filter) => delete currencyFilters[filter])
  return currencyFilters
}

export default browserQueryToQueryString
